import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Icons from 'components/Icons';

const examples = {
  pt: [
    <div className="guess">
      <div className="letter head">p</div>
      <div className="letter head">o</div>
      <div className="letter absent">s</div>
      <div className="letter absent">s</div>
      <div className="letter present">e</div>
    </div>,
    <div className="guess">
      <div className="letter absent">a</div>
      <div className="letter head">m</div>
      <div className="letter tail">p</div>
      <div className="letter tail">l</div>
      <div className="letter absent">a</div>
    </div>,
    <div className="guess">
      <div className="letter head start">e</div>
      <div className="letter tail">x</div>
      <div className="letter absent">i</div>
      <div className="letter absent">s</div>
      <div className="letter absent">t</div>
      <div className="letter head end">o</div>
    </div>,
    <div className="guess">
      <div className="letter head start">e</div>
      <div className="letter tail">x</div>
      <div className="letter tail">e</div>
      <div className="letter tail">m</div>
      <div className="letter tail">p</div>
      <div className="letter tail">l</div>
      <div className="letter tail end">o</div>
    </div>,
  ],
  en: [
    <div className="guess">
      <div className="letter head">p</div>
      <div className="letter head">e</div>
      <div className="letter absent">r</div>
      <div className="letter present">m</div>
      <div className="letter absent">i</div>
      <div className="letter absent">t</div>
    </div>,
    <div className="guess">
      <div className="letter absent">i</div>
      <div className="letter head">m</div>
      <div className="letter tail">p</div>
      <div className="letter tail">l</div>
      <div className="letter absent">y</div>
    </div>,
    <div className="guess">
      <div className="letter head start">e</div>
      <div className="letter tail">x</div>
      <div className="letter absent">c</div>
      <div className="letter absent">u</div>
      <div className="letter absent">s</div>
      <div className="letter head end">e</div>
    </div>,
    <div className="guess">
      <div className="letter head start">e</div>
      <div className="letter tail">x</div>
      <div className="letter tail">a</div>
      <div className="letter tail">m</div>
      <div className="letter tail">p</div>
      <div className="letter tail">l</div>
      <div className="letter tail end">e</div>
    </div>,
  ],
  es: [
    <div className="guess">
      <div className="letter head">p</div>
      <div className="letter head">o</div>
      <div className="letter absent">b</div>
      <div className="letter absent">r</div>
      <div className="letter present">e</div>
    </div>,
    <div className="guess">
      <div className="letter absent">a</div>
      <div className="letter head">m</div>
      <div className="letter tail">p</div>
      <div className="letter tail">l</div>
      <div className="letter absent">a</div>
    </div>,
    <div className="guess">
      <div className="letter head start">e</div>
      <div className="letter tail">j</div>
      <div className="letter tail">é</div>
      <div className="letter absent">r</div>
      <div className="letter absent">c</div>
      <div className="letter absent">i</div>
      <div className="letter absent">t</div>
      <div className="letter head end">o</div>
    </div>,
    <div className="guess">
      <div className="letter head start">e</div>
      <div className="letter tail">j</div>
      <div className="letter tail">e</div>
      <div className="letter tail">m</div>
      <div className="letter tail">p</div>
      <div className="letter tail">l</div>
      <div className="letter tail end">o</div>
    </div>,
  ],
  no: [
    <div className="guess">
      <div className="letter absent">i</div>
      <div className="letter head">m</div>
      <div className="letter head">e</div>
      <div className="letter absent">n</div>
      <div className="letter present">s</div>
    </div>,
    <div className="guess">
      <div className="letter absent">t</div>
      <div className="letter head">e</div>
      <div className="letter tail">m</div>
      <div className="letter tail">p</div>
      <div className="letter absent">o</div>
    </div>,
    <div className="guess">
      <div className="letter head start">e</div>
      <div className="letter absent">t</div>
      <div className="letter absent">a</div>
      <div className="letter absent">n</div>
      <div className="letter absent">o</div>
      <div className="letter head end">l</div>
    </div>,
    <div className="guess">
      <div className="letter head start">e</div>
      <div className="letter tail">k</div>
      <div className="letter tail">s</div>
      <div className="letter tail">e</div>
      <div className="letter tail">m</div>
      <div className="letter tail">p</div>
      <div className="letter tail">e</div>
      <div className="letter tail end">l</div>
    </div>,
  ],
};

function Instructions() {
  const { t } = useTranslation();
  const { language } = useParams();

  return (
    <div>
      <div className="modal-title">
        <Icons.Instructions />
        <h2>{t('instructionsModal.title')}</h2>
      </div>
      <div className="modal-content">
        <p>{t('instructionsModal.p1')}</p>
        {examples[language][0]}
        <p className="example-explanation">{t('instructionsModal.e1')}</p>
        {examples[language][1]}
        <p className="example-explanation">{t('instructionsModal.e2')}</p>
        {examples[language][2]}
        <p className="example-explanation">{t('instructionsModal.e3')}</p>
        {examples[language][3]}
        <p className="example-explanation">{t('instructionsModal.e4')}</p>
      </div>
    </div>
  );
}

export default Instructions;
